export default {
  order: 8,
  layerGroupId: 'GROUP_CLIMATE',
  dataLayer: {
    id: 'FOREST_CARBON_NET_FLUX',
    order: 8,
    type: 'remoteDataLayer',
    uuid: 'bd768c4b-f5f8-47f9-b6a0-5bb6078f0fac',
    groupId: 'GROUP_CLIMATE',
  },
  layer: {
    metadata: {
      metadata: null,
      legendConfig: {
        name: {
          en: 'Forest Greenhouse Net Flux (2001-2024)',
          fr: 'Flux net des serres forestières',
          es: 'Flujo neto de invernaderos forestales',
          pt: 'fluxo líquido de estufa florestal',
          id: 'arus bersih rumah kaca hutan',
          zh: '森林温室净通量',
          ka: 'орман климат павландыру желдерінің жалпы айналымы',
        },
        type: 'gradient',
        items: [
          {
            color: 'rgb(99, 39, 90)',
            name: {
              en: '>1500 tCO₂e ha⁻¹ (source)',
              fr: '>1500 tCO₂e ha⁻¹ (source)',
              es: '>1500 tCO₂e ha⁻¹ (Fuentes)',
              pt: '>1500 tCO₂e ha⁻¹ (Fontes)',
              id: '>1500 tCO₂e ha⁻¹ (Sumber)',
              zh: '>1500 tCO₂e ha⁻¹ (来源)',
              ka: '>1500 tCO₂e ha⁻¹ (წყაროები)',
              az: '>1500 tCO₂e ha⁻¹ (Qaynaq)',
              nl: '>1500 tCO₂e ha⁻¹ (Bronnen)',
              hy: '>1500 tCO₂e ha⁻¹ (աղբյուրները)',
            },
          },
          {
            color: 'rgb(190, 178, 230)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
              az: '',
              nl: '',
              hy: '',
            },
          },
          {
            color: 'rgb(221, 224, 209)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
              az: '',
              nl: '',
              hy: '',
            },
          },
          {
            color: 'rgb(111, 173, 139)',
            name: {
              en: '',
              fr: '',
              es: '',
              pt: '',
              id: '',
              zh: '',
              ka: '',
              az: '',
              nl: '',
              hy: '',
            },
          },
          {
            color: 'rgb(23, 136, 125)',
            name: {
              en: '<-1500 (Sink)',
              fr: '<-1500 (Puits)',
              es: '<-1500 (Sumideros)',
              pt: '<-1500 (Sumidouros)',
              id: '<-1500 (Sumur)',
              zh: '<-1500 (水槽)',
              ka: '<-1500 (ნიჟარები)',
              az: '<-1500 (çöküntü)',
              nl: '<-1500 (Putten)',
              hy: '<-1500 (լվացարաններ)',
            },
          },
        ],
      },
      interactionConfig: {},
    },
    id: 'FOREST_CARBON_NET_FLUX',
    type: 'forest-carbon-net-flux',
    url: 'https://tiles.globalforestwatch.org/gfw_forest_carbon_net_flux/v20250430/tcd_{tcd}/{z}/{x}/{y}.png',
    technicalName: 'wri_forest_carbon_net_flux',
    label: {
      en: 'Forest Greenhouse Net Flux',
      fr: 'Flux net des serres forestières',
      es: 'Flujo neto de invernaderos forestales',
      pt: 'fluxo líquido de estufa florestal',
      id: 'arus bersih rumah kaca hutan',
      zh: '森林温室净通量',
      ka: 'орман климат павландыру желдерінің жалпы айналымы',
    },
    sublabel: {
      en: '30m, global, 2001-2024, Harris et al. 2024',
      fr: '30m, global, 2001-2024, Harris et al. 2024',
      es: '30m, global, 2001-2024, Harris et al. 2024',
      pt: '30m, global, 2001-2024, Harris et al. 2024',
      id: '30m, global, 2001-2024, Harris et al. 2024',
      zh: '30m, global, 2001-2024, Harris et al. 2024',
      ka: '30m, global, 2001-2024, Harris et al. 2024',
    },
  },
  isMetadataError: false,
  isError: false,
};
